import { EventSourcePolyfill } from "event-source-polyfill";
import { ref } from "vue";
import axios from "axios";
const messages = ref([]);
// const notifications = ref([]);
let eventSource = null;

export function useSse() {
  const connect = (token) => {
    if (!eventSource) {
      let url = `${process.env.VUE_APP_RECEIPT_URL}/notification-service/ws/sse/subscribe`;
      eventSource = new EventSourcePolyfill(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      eventSource.addEventListener("HeartBeat", () => {
        // console.log("event", event);
        // try {
        //   const data = JSON.parse(event.data);
        //   messages.value.push(data);
        // } catch (err) {
        //   console.error("JSON parse error:", err);
        // }
      });
      let notifications = sessionStorage.getItem(token)
        ? JSON.parse(sessionStorage.getItem(token))
        : [];

      messages.value = notifications;

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          let notifications = sessionStorage.getItem(token)
            ? JSON.parse(sessionStorage.getItem(token))
            : [];

          // messages.value.push(data);
          notifications.push({ ...data, seen: false });
          messages.value = notifications;

          sessionStorage.setItem(token, JSON.stringify(notifications));
        } catch (err) {
          console.error("JSON parse error:", err);
        }
      };
      // eventSource.onerror = (err) => {
      //   console.error("SSE error:", err);
      //   disconnect();
      // };
    }
  };

  const disconnect = (token) => {
    sessionStorage.removeItem(token);
    if (eventSource) {
      let url = `${process.env.VUE_APP_RECEIPT_URL}/notification-service/ws/sse/unsubscribe`;
      axios.get(url);
      eventSource.close();
      eventSource = null;
    }
  };

  return {
    messages,
    connect,
    disconnect,
  };
}
